import gql from 'graphql-tag';

export const stripeIntegrationQuery = gql`
  query DocumentIntegrations {
    document {
      id
      stripeIntegration {
        metaData_1
        metaData_3
        hasToken
        externalUrl
      }
    }
  }
`;
